import { useEffect, useRef } from 'react';
import { Flex, Text } from '../../2022-component-library';
import { useToolDetection } from '../../helpers/distance-detection-hooks';
import { useReceiveMessage, usePostMessage } from '../../context/messageContext';
import { useCalibration } from '../../context/calibrationContext';

const CameraCalibration = () => {
  const { updateCalibrationData } = useCalibration();
  const canvasDOM = useRef(null);
  const videoDOM = useRef(null);
  const messageFromOptician = useReceiveMessage();
  const postMessage = usePostMessage();
  const { setShouldCalculatePerceivedFocalLength, calculatedPerceivedFocalLength, alertChange, setAlertChange } = useToolDetection({
    videoDOM,
    canvasDOM,
  });

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'initialiseToolDetections':
        setShouldCalculatePerceivedFocalLength(true);
        break;
      default:
        break;
    }
  }, [messageFromOptician.type, setShouldCalculatePerceivedFocalLength]);

  useEffect(() => {
    if (alertChange === true) {
      updateCalibrationData({ perceivedFocalLength: calculatedPerceivedFocalLength });
      postMessage({
        type: 'perceivedFocalLength',
        content: { perceivedFocalLength: calculatedPerceivedFocalLength },
      });
      setAlertChange(false);
    }
  }, [calculatedPerceivedFocalLength, alertChange, updateCalibrationData, postMessage, setAlertChange]);

  return (
    <Flex alignItems='center' justifyContent='center'>
      <video id='video' width='100%' style={{ display: 'none' }} ref={videoDOM}>
        Video stream not available.
      </video>
      <canvas id='canvas' style={{ display: 'none' }} ref={canvasDOM}></canvas>
      <Text size='h1'>Position the tool and ask the clinician to start the calibration.</Text>
    </Flex>
  );
};

export default CameraCalibration;
